// src/auth/useAuth.ts
import { createContext, useContext } from "react";
import type { AccountInfo } from "@azure/msal-browser";

export type AuthContextType = {
  account: AccountInfo | null;
  // login is kept here so other components can still call it if needed.
  // The implementation will typically wrap msalInstance.loginRedirect(...)
  login: () => void;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
